// src/components/home/Accordion.tsx
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { FaChevronDown } from "react-icons/fa"
import "./style/Stats.scss"

type Faq = {
  question: string
  answer: string
}

const Accordion: React.FC = () => {
  const { t } = useTranslation()
  
  // Pull your array of FAQs from i18n
  const faqs = t("home.faqs", { returnObjects: true }) as Faq[]

  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggle = (i: number) => {
    setOpenIndex((prev) => (prev === i ? null : i))
  }

  return (
    <section className="accordion-section">
      <h2>{t("home.commonQuestions") /* add this key if needed */}</h2>
      <div className="accordion-list">
        {faqs.map((item, i) => {
          const isOpen = openIndex === i
          return (
            <div
              key={i}
              className={`accordion-item ${isOpen ? "open" : ""}`}
            >
              <button
                className="accordion-header"
                onClick={() => toggle(i)}
              >
                <span className="index">Q{i + 1}</span>
                <span className="question">{item.question}</span>
                <FaChevronDown
                  className={`arrow ${isOpen ? "rotate" : ""}`}
                />
              </button>
              <div
                className="accordion-body"
                style={{
                  maxHeight: isOpen ? "200px" : "0",
                  opacity: isOpen ? 1 : 0
                }}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Accordion
